import StoreModuleService from '../../../StoreModuleService';
import { MODULE_NAME } from './const';
import { isNullOrUndefined } from '@/utils/helpers';

const buildWorkflowVersionGetterObject = (getter) => StoreModuleService.buildGetterObject(MODULE_NAME, getter);

// getters declarations
export const getWorkflowVersion = buildWorkflowVersionGetterObject('getWorkflowVersion');
export const useSelectedWorkflowVersionId = buildWorkflowVersionGetterObject('useSelectedWorkflowVersionId');
export const useSelectedWorkflowSelectedVersion = buildWorkflowVersionGetterObject('useSelectedWorkflowSelectedVersion');
export const isVersionHistoryOpen = buildWorkflowVersionGetterObject('isVersionHistoryOpen');

const getters = {
	[useSelectedWorkflowVersionId.getter]: (state) => state.selectedWorkflowVersionId,
	[getWorkflowVersion.getter]: (state) => (workflowVersionId) => state.data[workflowVersionId],
	[useSelectedWorkflowSelectedVersion.getter]: (state, getters) =>
		getters[getWorkflowVersion.getter](getters[useSelectedWorkflowVersionId.getter]),
	[isVersionHistoryOpen.getter]: (state, getters) => !isNullOrUndefined(getters[useSelectedWorkflowVersionId.getter]),
};

export default getters;
